<h2 mat-dialog-title>Upload Metadata File</h2>
<mat-dialog-content>
  <input type="file" class="custom-file-input" id="inputGroupFile01" aria-describedby="inputGroupFileAddon01"
    (change)="onFileChanged($event)">
  <label style="display: none" class="custom-file-label" #labelImport for="inputGroupFile01">Choose file</label>

</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" mat-dialog-close>Cancel</button>
</mat-dialog-actions>